import * as React from 'react';
import { cn } from '@/lib/utils';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-md bg-muted',
        className,
      )}
      {...props}
    >
      <div
        aria-hidden
        className="absolute inset-0 animate-skeleton-sweep bg-gradient-to-r from-transparent via-white/55 to-transparent dark:via-white/10"
      />
    </div>
  );
}

export default Skeleton;
